import api from './api';

export const orderService = {
    createOrder: async (orderData) => {
        try {
            const response = await api.post('/orders', orderData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getUserOrders: async () => {
        try {
            const response = await api.get('/orders/myorders');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Tutti gli ordini del negozio (admin only)
    getAllOrders: async () => {
        try {
            const response = await api.get('/orders');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getOrderById: async (id) => {
        try {
            const response = await api.get(`/orders/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Traccia un ordine tramite il codice breve (8 caratteri), senza richiedere login
    getOrderByShortId: async (shortId) => {
        try {
            const response = await api.get(`/orders/track/${shortId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateOrderStatus: async (id, status) => {
        try {
            const response = await api.put(`/orders/${id}/status`, { status });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Cancella il proprio ordine (utente — solo pending/processing)
    cancelOrder: async (id) => {
        try {
            const response = await api.put(`/orders/${id}/cancel`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Elimina ordine (admin)
    deleteOrder: async (id) => {
        try {
            const response = await api.delete(`/orders/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
};